import { render, staticRenderFns } from "./WaiterTemplateInputItem.vue?vue&type=template&id=5765cb95&scoped=true&lang=pug"
import script from "./WaiterTemplateInputItem.vue?vue&type=script&lang=ts"
export * from "./WaiterTemplateInputItem.vue?vue&type=script&lang=ts"
import style0 from "./WaiterTemplateInputItem.vue?vue&type=style&index=0&id=5765cb95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5765cb95",
  null
  
)

export default component.exports